import { CollectionResource } from 'dy-frontend-http-repository/lib/data/resources';
import { TimeTrackingEntryResource } from 'dy-frontend-http-repository/lib/modules/TimeTacking/resources';

import domain from './domain';
import { resetWorkReports } from './events';

// Task messages
export const $workReports = domain
    .createStore<CollectionResource<TimeTrackingEntryResource, {}> | null>(null)
    .reset(resetWorkReports);
